import React from 'react'
import { utils, records } from '@ims/1edtech-frontend-common'

import { useSelector } from 'react-redux'
import ICharacterization from 'domains/characterizations/models/ICharacterization'
import { ICommonCartridgeItem } from 'domains/commonCartridge/models/ICommonCartridgeItem'
import { View } from 'lib/components'
import { COMMON_CARTRIDGE_CHARACTERIZATION_REPORT_RESOURCES_RECORD } from 'lib/records/modules/commonCartridgeCharacterizationReportResources'
import CCCharacterizationReportResourceRow from 'domains/commonCartridge/components/CommonCartridgeCharacterizationReport/CCCharacterizationReportResourceRow'

interface IProps {
  id: number
  characterization: ICharacterization
}

export default function CCCharacterizationReportTableResourceRow(
  props: IProps,
) {
  const resource = useSelector(
    records.entitiesSelectors.entityByIdSelector(
      COMMON_CARTRIDGE_CHARACTERIZATION_REPORT_RESOURCES_RECORD,
      utils.convertToInt(props.id),
    ),
  ) as ICommonCartridgeItem

  return (
    <View mb={2}>
      <CCCharacterizationReportResourceRow
        characterization={props.characterization}
        resource={resource}
      />
    </View>
  )
}
